/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/iframe-has-title */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Accordion, Card } from "react-bootstrap";
import _ from "lodash";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import TabletBreakpoint from "util/responsive/tablet_breakpoint";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import requireAuth from "components/hoc/requireAuth";
import { getFaq } from "actions";
import { Trans } from "react-i18next";

const mobileCategoryListVisibleStyle = {
  visibility: "visible",
  opacity: "1",
  display: "block",
};
const mobileCategoryListInVisibleStyle = {
  visibility: "hidden",
  opacity: "0",
  display: "none",
};
class Faq extends Component {
  state = {
    faqFetched: false,
    selectedCategoryId: 0,
    selectedQuestionIdx: 0,
    toggledClassnames: {},
    categoryStyles: {},
    mobileCategoryListVisible: false,
  };

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps, prevState) {
  }

  fetchData = () => {
    this.props.getFaq(this.onBegin, this.onSuccess, this.onError);
  };

  onBegin = () => {
    this.props.onProcessBegin();
  };

  onError = (err) => {
    console.log(err);
    this.props.onProcessEnd();
  };

  onSuccess = () => {
    this.props.onProcessEnd();
    let categoryStyles = { ...this.state.categoryStyles };
    categoryStyles[this.props.faq.data[0].id] = { backgroundColor: "#002e6d" };

    let toggledClassnames = {};

    this.props.faq.data.map((cat) => {
      return cat.questions.map((q, idx) => {
        return (toggledClassnames[`${cat.id}_${idx}`] =
          "btn btn-link collapsed");
      });
    });

    this.setState({
      faqFetched: true,
      selectedCategoryId: this.props.faq.data[0].id,
      categoryStyles: { ...categoryStyles },
      toggledClassnames: { ...toggledClassnames },
    });
  };

  handleCategorySelect = (cid) => {
    let categoryStyles = this.resetCategoryStyles();
    categoryStyles[cid] = { backgroundColor: "#002e6d" };
    this.setState({
      selectedCategoryId: cid,
      toggledClassnames: { ...this.resetAllClassNames() },
      activeKey: null,
      categoryStyles: { categoryStyles },
      mobileCategoryListVisible: false,
    });
  };

  resetCategoryStyles = () => {
    let categoryStyles = { ...this.state.categoryStyles };
    _.forIn(categoryStyles, (v, k) => {
      categoryStyles[k] = "";
    });
    return categoryStyles;
  };

  resetAllClassNames = () => {
    let tmp = { ...this.state.toggledClassnames };
    return _.forIn(tmp, (v, k) => {
      tmp[k] = "btn btn-link collapsed";
      // console.log(tmp[k]);
    });
  };

  handleAccordionToggle = (eventkey) => {
    let categoryId = eventkey.split("_")[0];
    let tmpCategoryStyles = { ...this.state.categoryStyles };
    let tempToggledClassnames = this.resetAllClassNames();
    let activeKey = this.state.activeKey;

    if (this.state.toggledClassnames[eventkey].indexOf("collapsed") > 0) {
      tempToggledClassnames[eventkey] = "btn btn-link";
      activeKey = eventkey;
    } else {
      tempToggledClassnames[eventkey] = "btn btn-link collapsed";
      activeKey = null;
    }
    tmpCategoryStyles[categoryId] = { backgroundColor: "#002e6d" };
    this.setState({
      toggledClassnames: { ...tempToggledClassnames },
      activeKey: activeKey,
      categoryStyles: { ...tmpCategoryStyles },
    });
  };

  renderQuestions = () => {
    let categoryId = this.state.selectedCategoryId;

    let categoryQuestions = this.props.faq.data.filter((c) => {
      return c.id === categoryId;
    });
    categoryQuestions = categoryQuestions[0].questions.map((q, idx) => {
      return (
        <Card key={`${categoryId}_${idx}`}>
          <Card.Header>
            <Accordion.Toggle
              as="h2"
              className="mb-0"
              eventKey={`${categoryId}_${idx}`}
              onClick={() => this.handleAccordionToggle(`${categoryId}_${idx}`)}
            >
              <button
                className={this.state.toggledClassnames[`${categoryId}_${idx}`]}
                type="button"
                dangerouslySetInnerHTML={{
                  __html: q.question,
                }}
              ></button>
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey={`${categoryId}_${idx}`}>
            <Card.Body
            > <div dangerouslySetInnerHTML={{ __html: q.answer }} />
              {q.link && <><br /><a href={q.link} target="_blank" rel="noopener noreferrer">{q.urlName}</a></>}
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      );
    });

    return (
      <Accordion
        className="sssAccordion"
        activeKey={this.state.activeKey}
        defaultActiveKey="0"
      >
        {categoryQuestions}
      </Accordion>
    );
  };

  toggleMobileCategoryList = () => {
    if (this.state.mobileCategoryListVisible) {
      this.setState({ mobileCategoryListVisible: false });
    } else {
      this.setState({ mobileCategoryListVisible: true });
    }
  };

  renderSelectedCategoryMobile = () => {
    return (
      <div className="custom-select__trigger">
        <span>
          {
            this.props.faq.data.find(
              (f) => f.id === this.state.selectedCategoryId
            ).name
          }
        </span>
        <span className="iconmford fo-icon-expand-more"></span>
      </div>
    );
  };

  render() {
    if (!this.state.faqFetched) {
      return this.props.spinner;
    }

    return (
      <section className="sssArea my-3">
        <div className="container">
          <div className="row d-none d-sm-none d-md-flex d-lg-flex py-4 topRow align-items-center">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <ul className="fgaBreadcrumb">
                <li>
                  <a href="/" style={{ verticalAlign: "middle" }}>
                    <span className="iconmford fo-icon-home"></span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <Trans desc="Kurumsal">10026</Trans>
                  </a>
                </li>
                <li className="active">
                  <Trans desc="Sıkça Sorulan Sorular">10041</Trans>
                </li>
              </ul>
            </div>
          </div>
          <div className="row d-flex d-sm-flex d-md-none d-lg-none py-4 topRow">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div className="sssBaslik">
                <Trans desc="Sıkça Sorulan Sorular">10041</Trans>
              </div>
            </div>
          </div>
          <TabletBreakpoint>
            <div className="row d-flex d-sm-flex kategoriSecimAlani">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div
                  className="custom-select-wrapper"
                  id="sssKategoriSecenekleri_1"
                >
                  <div
                    className="custom-select categorySelect"
                    onClick={this.toggleMobileCategoryList}
                  >
                    {this.renderSelectedCategoryMobile()}

                    <div
                      className="custom-options ssskategoriListesi"
                      style={
                        this.state.mobileCategoryListVisible
                          ? mobileCategoryListVisibleStyle
                          : mobileCategoryListInVisibleStyle
                      }
                    >
                      {this.props.faq.data.map((category) => {
                        return (
                          <span
                            className="custom-option etoGraphType selected"
                            key={category.id}
                            onClick={(e) =>
                              this.handleCategorySelect(category.id)
                            }
                          >
                            {category.name
                              ? category.name
                              : "KATEGORİ İSMİ YOK!!!!"}
                          </span>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </TabletBreakpoint>

          <div className="row py-4 bottomRow">
            <DesktopBreakpoint>
              <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 d-none d-sm-none d-md-flex d-lg-flex">
                <ul className="sssSideMenu">
                  {this.props.faq.data.map((category) => {
                    return (
                      <li
                        style={this.state.categoryStyles[category.id]}
                        key={category.id}
                        onClick={() => {
                          this.handleCategorySelect(category.id);
                        }}
                      >
                        <span>
                          {category.name
                            ? category.name
                            : "KATEGORİ İSMİ YOK!!!!"}
                        </span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </DesktopBreakpoint>
            <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8">
              {this.renderQuestions()}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = ({ faq, application }) => {
  return {
    faq,
    application,
  };
};

export default connect(mapStateToProps, { getFaq })(
  containsLongRunningProcess(requireAuth(Faq))
);
